import { OndigoNS } from '../../modules/main.js';

(function ($) {
    'use strict';

    // class definition
    OndigoNS.OpenimmoSearchFilter = function (element) {

        this.$form = $(element);
        this.initSearch();
    };

    OndigoNS.OpenimmoSearchFilter.prototype = {
        initSearch: function () {
            var scope = this,
                $url=decodeURIComponent(window.location),
                params="";

            params= scope.getUrlParameter($url);
            scope.filterResults(params);
        },

        getUrlParameter:function (url){
            var splittedUrl = url.toString().split('#'),
                params="";

                if(splittedUrl.length>1) {
                    params = splittedUrl[1].split('&');
                }
            return params;
        },

        filterResults: function(params) {
            var filter="",
                value="";
            var $typefilter = $('#filterBoxType');
            var $regionfilter = $('#filterBoxRegion');

            $('.idNotFound').css("display", "none");

            $(params).each(function(){
                filter=this.toString().split("=")[0];
                value= this.toString().split("=")[1];

                if(filter=="IdnotFound"){

                    $('.idNotFound').css("display", "block");
                }else{
                    $('.idNotFound').css("display", "none");
                }

                if(filter=="type"){

                    $('#filterBoxType input[data-category="'+value+'"]').prop("checked",true);
                }

                if(filter=="region"){

                    $('#filterBoxRegion input[data-township="'+value+'"]').prop("checked",true);
                }

            });
        }
    };
    // plugin definition

    $.fn.openimmoSearchFilter = function () {
        return new OndigoNS.OpenimmoSearchFilter(this);
    };
    $.fn.openimmoSearchFilter.Constructor = OndigoNS.OpenimmoSearchFilter;

}(window.jQuery));

$(document).ready(function () {
    'use strict';

    var $typefilter = $('#filterBoxType');
    var $regionfilter = $('#filterBoxRegion');

    if ($typefilter.length) {
        $typefilter.openimmoSearchFilter();
    }

});